import { authentication } from 'common/help/indepentBizAuthentication';

export default options => {
  const { bizType } = nx.hashlize();

  if (bizType === 'independent') {
    options.url = authentication(options.url);
  }

  return options;
};
